import { render } from "./TicketList.vue?vue&type=template&id=48dd96ae&scoped=true"
import script from "./TicketList.vue?vue&type=script&lang=js"
export * from "./TicketList.vue?vue&type=script&lang=js"

import "./TicketList.vue?vue&type=style&index=0&id=48dd96ae&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dd96ae"]])

export default __exports__